import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { rehydrate, rehydrateFailure } from 'src/app/calvin-emr-shared/state/auth/auth.actions';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [NavBarComponent, ToastModule],
})
export class AppComponent {
  title = 'calvin-emr';

  constructor(private store: Store, private router: Router) {
    const auth = getAuth();

    onAuthStateChanged(auth, (user) => {
      if (user !== null) {
        this.store.dispatch(rehydrate({ userId: user.uid }));
      } else {
        this.store.dispatch(rehydrateFailure());
      }
    });
  }
}
